export const states = [
  { title: "Alabama" },
  { title: "Alaska" },
  { title: "Arizona" },
  { title: "Arkansas" },
  { title: "California" },
  { title: "Colorado" },
  { title: "Connecticut" },
  { title: "Delaware" },
  { title: "Florida" },
  { title: "Georgia" },
  { title: "Hawaii" },
  { title: "Idaho" },
  { title: "Illinois" },
  { title: "Indiana" },
  { title: "Iowa" },
  { title: "Kansas" },
  { title: "Kentucky" },
  { title: "Louisiana" },
  { title: "Maine" },
  { title: "Maryland" },
  { title: "Massachusetts" },
  { title: "Michigan" },
  { title: "Minnesota" },
  { title: "Mississippi" },
  { title: "Missouri" },
  { title: "Montana" },
  { title: "Nebraska" },
  { title: "Nevada" },
  { title: "New Hampshire" },
  { title: "New Jersey" },
  { title: " New Mexico" },
  { title: " New York" },
  { title: " North Carolina" },
  { title: "North Dakota" },
  { title: "Ohio" },
  { title: "Oklahoma" },
  { title: "Oregon" },
  { title: "Pennsylvania" },
  { title: " Rhode Island" },
  { title: "South Carolina" },
  { title: "South Dakota" },
  { title: "Tennessee" },
  { title: "Texas" },
  { title: "Utah" },
  { title: "Vermont" },
  { title: "Virginia" },
  { title: "Washington" },
  { title: "West Virginia" },
  { title: "Wisconsin" },
  { title: "Wyoming" },
];

export const Countries = [
  {
    id: 3,
    name: "Afghanistan",
    title: "Afghanistan",
  },
  {
    id: 4,
    name: "Aland Islands",
    title: "Aland Islands",
  },
  {
    id: 5,
    name: "Albania",
    title: "Albania",
  },
  {
    id: 6,
    name: "Algeria",
    title: "Algeria",
  },
  {
    id: 7,
    name: "American Samoa",
    title: "American Samoa",
  },
  {
    id: 8,
    name: "Andorra",
    title: "Andorra",
  },
  {
    id: 9,
    name: "Angola",
    title: "Angola",
  },
  {
    id: 11,
    name: "Antarctica",
    title: "Antarctica",
  },
  {
    id: 12,
    name: "Antigua and Barbuda",
    title: "Antigua and Barbuda",
  },
  {
    id: 13,
    name: "Argentina",
    title: "Argentina",
  },
  {
    id: 14,
    name: "Malaysia",
    title: "Malaysia",
  },
  {
    id: 15,
    name: "Aruba",
    title: "Aruba",
  },
  {
    id: 16,
    name: "Australia",
    title: "Australia",
  },
  {
    id: 17,
    name: "Austria",
    title: "Austria",
  },
  {
    id: 18,
    name: "Azerbaijan",
    title: "Azerbaijan",
  },
  {
    id: 19,
    name: "Bahamas",
    title: "Bahamas",
  },
  {
    id: 20,
    name: "Bahrain",
    title: "Bahrain",
  },
  {
    id: 21,
    name: "Bangladesh",
    title: "Bangladesh",
  },
  {
    id: 22,
    name: "Barbados",
    title: "Barbados",
  },
  {
    id: 23,
    name: "Belarus",
    title: "Belarus",
  },
  {
    id: 27,
    name: "Bermuda",
    title: "Bermuda",
  },
  {
    id: 28,
    name: "Bhutan",
    title: "Bhutan",
  },
  {
    id: 29,
    name: "Bolivia",
    title: "Bolivia",
  },
  {
    id: 30,
    name: "Bonaire, Sint Eustatius and Saba",
    title: "Bonaire, Sint Eustatius and Saba",
  },
  {
    id: 31,
    name: "Bosnia and Herzegovina",
    title: "Bosnia and Herzegovina",
  },
  {
    id: 32,
    name: "Botswana",
    title: "Botswana",
  },
  {
    id: 33,
    name: "Bouvet Island",
    title: "Bouvet Island",
  },
  {
    id: 34,
    name: "Brazil",
    title: "Brazil",
  },
  {
    id: 35,
    name: "British Indian Ocean Territory",
    title: "British Indian Ocean Territory",
  },
  {
    id: 37,
    name: "Bulgaria",
    title: "Bulgaria",
  },
  {
    id: 38,
    name: "Burkina Faso",
    title: "Burkina Faso",
  },
  {
    id: 40,
    name: "Cambodia",
    title: "Cambodia",
  },
  {
    id: 41,
    name: "Cameroon",
    title: "Cameroon",
  },
  {
    id: 42,
    name: "Canada",
    title: "Canada",
  },
  {
    id: 43,
    name: "Cape Verde",
    title: "Cape Verde",
  },
  {
    id: 44,
    name: "Cayman Islands",
    title: "Cayman Islands",
  },
  {
    id: 45,
    name: "Central African Republic",
    title: "Central African Republic",
  },
  {
    id: 46,
    name: "Chad",
    title: "Chad",
  },
  {
    id: 48,
    name: "China",
    title: "China",
  },
  {
    id: 49,
    name: "Christmas Island",
    title: "Christmas Island",
  },
  {
    id: 50,
    name: "Cocos (Keeling) Islands",
    title: "Cocos (Keeling) Islands",
  },
  {
    id: 51,
    name: "Colombia",
    title: "Colombia",
  },
  {
    id: 54,
    name: "Cook Islands",
    title: "Cook Islands",
  },
  {
    id: 55,
    name: "Costa Rica",
    title: "Costa Rica",
  },
  {
    id: 56,
    name: "Ivory Coast",
    title: "Ivory Coast",
  },
  {
    id: 57,
    name: "Croatia",
    title: "Croatia",
  },
  {
    id: 58,
    name: "Cuba",
    title: "Cuba",
  },
  {
    id: 59,
    name: "Curacao",
    title: "Curacao",
  },
  {
    id: 62,
    name: "Democratic Republic of the Congo",
    title: "Democratic Republic of the Congo",
  },
  {
    id: 63,
    name: "Denmark",
    title: "Denmark",
  },
  {
    id: 65,
    name: "Dominica",
    title: "Dominica",
  },
  {
    id: 66,
    name: "Dominican Republic",
    title: "Dominican Republic",
  },
  {
    id: 67,
    name: "Ecuador",
    title: "Ecuador",
  },
  {
    id: 69,
    name: "El Salvador",
    title: "El Salvador",
  },
  {
    id: 70,
    name: "Equatorial Guinea",
    title: "Equatorial Guinea",
  },
  {
    id: 71,
    name: "Eritrea",
    title: "Eritrea",
  },
  {
    id: 72,
    name: "Estonia",
    title: "Estonia",
  },
  {
    id: 73,
    name: "Ethiopia",
    title: "Ethiopia",
  },
  {
    id: 74,
    name: "Falkland Islands (Malvinas)",
    title: "Falkland Islands (Malvinas)",
  },
  {
    id: 75,
    name: "Faroe Islands",
    title: "Faroe Islands",
  },
  {
    id: 77,
    name: "Finland",
    title: "Finland",
  },
  {
    id: 78,
    name: "France",
    title: "France",
  },
  {
    id: 79,
    name: "French Guiana",
    title: "French Guiana",
  },
  {
    id: 80,
    name: "French Polynesia",
    title: "French Polynesia",
  },
  {
    id: 82,
    name: "Gabon",
    title: "Gabon",
  },
  {
    id: 83,
    name: "Gambia",
    title: "Gambia",
  },
  {
    id: 84,
    name: "Georgia",
    title: "Georgia",
  },
  {
    id: 85,
    name: "Germany",
    title: "Germany",
  },
  {
    id: 86,
    name: "Ghana",
    title: "Ghana",
  },
  {
    id: 87,
    name: "Gibraltar",
    title: "Gibraltar",
  },
  {
    id: 89,
    name: "Greenland",
    title: "Greenland",
  },
  {
    id: 90,
    name: "Grenada",
    title: "Grenada",
  },
  {
    id: 91,
    name: "Guadaloupe",
    title: "Guadaloupe",
  },
  {
    id: 92,
    name: "Guam",
    title: "Guam",
  },
  {
    id: 93,
    name: "Guatemala",
    title: "Guatemala",
  },
  {
    id: 95,
    name: "Guinea",
    title: "Guinea",
  },
  {
    id: 96,
    name: "Guinea-Bissau",
    title: "Guinea-Bissau",
  },
  {
    id: 97,
    name: "Guyana",
    title: "Guyana",
  },
  {
    id: 98,
    name: "Haiti",
    title: "Haiti",
  },
  {
    id: 99,
    name: "Heard Island and McDonald Islands",
    title: "Heard Island and McDonald Islands",
  },
  {
    id: 100,
    name: "Honduras",
    title: "Honduras",
  },
  {
    id: 102,
    name: "Hungary",
    title: "Hungary",
  },
  {
    id: 103,
    name: "Iceland",
    title: "Iceland",
  },
  {
    id: 104,
    name: "India",
    title: "India",
  },
  {
    id: 105,
    name: "Indonesia",
    title: "Indonesia",
  },
  {
    id: 106,
    name: "Iran",
    title: "Iran",
  },
  {
    id: 107,
    name: "Iraq",
    title: "Iraq",
  },
  {
    id: 108,
    name: "Ireland",
    title: "Ireland",
  },
  {
    id: 109,
    name: "Isle of Man",
    title: "Isle of Man",
  },
  {
    id: 110,
    name: "Israel",
    title: "Israel",
  },
  {
    id: 111,
    name: "Italy",
    title: "Italy",
  },
  {
    id: 112,
    name: "Jamaica",
    title: "Jamaica",
  },
  {
    id: 113,
    name: "Japan",
    title: "Japan",
  },
  {
    id: 115,
    name: "Jordan",
    title: "Jordan",
  },
  {
    id: 116,
    name: "Kazakhstan",
    title: "Kazakhstan",
  },
  {
    id: 117,
    name: "Kenya",
    title: "Kenya",
  },
  {
    id: 118,
    name: "Kiribati",
    title: "Kiribati",
  },
  {
    id: 120,
    name: "Kuwait",
    title: "Kuwait",
  },
  {
    id: 121,
    name: "Kyrgyzstan",
    title: "Kyrgyzstan",
  },
  {
    id: 122,
    name: "Laos",
    title: "Laos",
  },
  {
    id: 123,
    name: "Latvia",
    title: "Latvia",
  },
  {
    id: 124,
    name: "Lebanon",
    title: "Lebanon",
  },
  {
    id: 126,
    name: "Liberia",
    title: "Liberia",
  },
  {
    id: 127,
    name: "Libya",
    title: "Libya",
  },
  {
    id: 129,
    name: "Lithuania",
    title: "Lithuania",
  },
  {
    id: 131,
    name: "Macao",
    title: "Macao",
  },
  {
    id: 132,
    name: "Macedonia",
    title: "Macedonia",
  },
  {
    id: 133,
    name: "Madagascar",
    title: "Madagascar",
  },
  {
    id: 134,
    name: "Malawi",
    title: "Malawi",
  },
  {
    id: 136,
    name: "Maldives",
    title: "Maldives",
  },
  {
    id: 137,
    name: "Mali",
    title: "Mali",
  },
  {
    id: 138,
    name: "Malta",
    title: "Malta",
  },
  {
    id: 139,
    name: "Marshall Islands",
    title: "Marshall Islands",
  },
  {
    id: 140,
    name: "Martinique",
    title: "Martinique",
  },
  {
    id: 141,
    name: "Mauritania",
    title: "Mauritania",
  },
  {
    id: 142,
    name: "Mauritius",
    title: "Mauritius",
  },
  {
    id: 143,
    name: "Mayotte",
    title: "Mayotte",
  },
  {
    id: 145,
    name: "Micronesia",
    title: "Micronesia",
  },
  {
    id: 146,
    name: "Moldava",
    title: "Moldava",
  },
  {
    id: 147,
    name: "Monaco",
    title: "Monaco",
  },
  {
    id: 148,
    name: "Mongolia",
    title: "Mongolia",
  },
  {
    id: 150,
    name: "Montserrat",
    title: "Montserrat",
  },
  {
    id: 152,
    name: "Mozambique",
    title: "Mozambique",
  },
  {
    id: 153,
    name: "Myanmar (Burma)",
    title: "Myanmar (Burma)",
  },
  {
    id: 154,
    name: "Namibia",
    title: "Namibia",
  },
  {
    id: 155,
    name: "Nauru",
    title: "Nauru",
  },
  {
    id: 156,
    name: "Nepal",
    title: "Nepal",
  },
  {
    id: 157,
    name: "Netherlands",
    title: "Netherlands",
  },
  {
    id: 158,
    name: "New Caledonia",
    title: "New Caledonia",
  },
  {
    id: 159,
    name: "New Zealand",
    title: "New Zealand",
  },
  {
    id: 160,
    name: "Nicaragua",
    title: "Nicaragua",
  },
  {
    id: 162,
    name: "Nigeria",
    title: "Nigeria",
  },
  {
    id: 164,
    name: "Norfolk Island",
    title: "Norfolk Island",
  },
  {
    id: 165,
    name: "North Korea",
    title: "North Korea",
  },
  {
    id: 166,
    name: "Northern Mariana Islands",
    title: "Northern Mariana Islands",
  },
  {
    id: 167,
    name: "Norway",
    title: "Norway",
  },
  {
    id: 168,
    name: "Oman",
    title: "Oman",
  },
  {
    id: 169,
    name: "Pakistan",
    title: "Pakistan",
  },
  {
    id: 170,
    name: "Palau",
    title: "Palau",
  },
  {
    id: 171,
    name: "Palestine",
    title: "Palestine",
  },
  {
    id: 172,
    name: "Panama",
    title: "Panama",
  },
  {
    id: 173,
    name: "Papua New Guinea",
    title: "Papua New Guinea",
  },
  {
    id: 174,
    name: "Paraguay",
    title: "Paraguay",
  },
  {
    id: 177,
    name: "Pitcairn",
    title: "Pitcairn",
  },
  {
    id: 178,
    name: "Poland",
    title: "Poland",
  },
  {
    id: 179,
    name: "Portugal",
    title: "Portugal",
  },
  {
    id: 181,
    name: "Qatar",
    title: "Qatar",
  },
  {
    id: 183,
    name: "Romania",
    title: "Romania",
  },
  {
    id: 184,
    name: "Russia",
    title: "Russia",
  },
  {
    id: 185,
    name: "Rwanda",
    title: "Rwanda",
  },
  {
    id: 186,
    name: "Saint Barthelemy",
    title: "Saint Barthelemy",
  },
  {
    id: 187,
    name: "Saint Helena",
    title: "Saint Helena",
  },
  {
    id: 188,
    name: "Saint Kitts and Nevis",
    title: "Saint Kitts and Nevis",
  },
  {
    id: 189,
    name: "Saint Lucia",
    title: "Saint Lucia",
  },
  {
    id: 190,
    name: "Saint Martin",
    title: "Saint Martin",
  },
  {
    id: 191,
    name: "Saint Pierre and Miquelon",
    title: "Saint Pierre and Miquelon",
  },
  {
    id: 192,
    name: "Saint Vincent and the Grenadines",
    title: "Saint Vincent and the Grenadines",
  },
  {
    id: 193,
    name: "Samoa",
    title: "Samoa",
  },
  {
    id: 194,
    name: "San Marino",
    title: "San Marino",
  },
  {
    id: 195,
    name: "Sao Tome and Principe",
    title: "Sao Tome and Principe",
  },
  {
    id: 196,
    name: "Saudi Arabia",
    title: "Saudi Arabia",
  },
  {
    id: 197,
    name: "Senegal",
    title: "Senegal",
  },
  {
    id: 198,
    name: "Serbia",
    title: "Serbia",
  },
  {
    id: 200,
    name: "Sierra Leone",
    title: "Sierra Leone",
  },
  {
    id: 201,
    name: "Singapore",
    title: "Singapore",
  },
  {
    id: 202,
    name: "Sint Maarten",
    title: "Sint Maarten",
  },
  {
    id: 203,
    name: "Slovakia",
    title: "Slovakia",
  },
  {
    id: 204,
    name: "Slovenia",
    title: "Slovenia",
  },
  {
    id: 205,
    name: "Solomon Islands",
    title: "Solomon Islands",
  },
  {
    id: 206,
    name: "Somalia",
    title: "Somalia",
  },
  {
    id: 207,
    name: "South Africa",
    title: "South Africa",
  },
  {
    id: 208,
    name: "South Georgia and the South Sandwich Islands",
    title: "South Georgia and the South Sandwich Islands",
  },
  {
    id: 209,
    name: "South Korea",
    title: "South Korea",
  },
  {
    id: 210,
    name: "South Sudan",
    title: "South Sudan",
  },
  {
    id: 211,
    name: "Spain",
    title: "Spain",
  },
  {
    id: 212,
    name: "Sri Lanka",
    title: "Sri Lanka",
  },
  {
    id: 213,
    name: "Sudan",
    title: "Sudan",
  },
  {
    id: 214,
    name: "Suriname",
    title: "Suriname",
  },
  {
    id: 215,
    name: "Svalbard and Jan Mayen",
    title: "Svalbard and Jan Mayen",
  },
  {
    id: 216,
    name: "Swaziland",
    title: "Swaziland",
  },
  {
    id: 218,
    name: "Switzerland",
    title: "Switzerland",
  },
  {
    id: 219,
    name: "Syria",
    title: "Syria",
  },
  {
    id: 220,
    name: "Taiwan",
    title: "Taiwan",
  },
  {
    id: 221,
    name: "Tajikistan",
    title: "Tajikistan",
  },
  {
    id: 222,
    name: "Tanzania",
    title: "Tanzania",
  },
  {
    id: 223,
    name: "Thailand",
    title: "Thailand",
  },
  {
    id: 224,
    name: "Timor-Leste (East Timor)",
    title: "Timor-Leste (East Timor)",
  },
  {
    id: 226,
    name: "Tokelau",
    title: "Tokelau",
  },
  {
    id: 227,
    name: "Tonga",
    title: "Tonga",
  },
  {
    id: 228,
    name: "Trinidad and Tobago",
    title: "Trinidad and Tobago",
  },
  {
    id: 229,
    name: "Tunisia",
    title: "Tunisia",
  },
  {
    id: 231,
    name: "Turkmenistan",
    title: "Turkmenistan",
  },
  {
    id: 232,
    name: "Turks and Caicos Islands",
    title: "Turks and Caicos Islands",
  },
  {
    id: 233,
    name: "Tuvalu",
    title: "Tuvalu",
  },
  {
    id: 234,
    name: "Uganda",
    title: "Uganda",
  },
  {
    id: 235,
    name: "Ukraine",
    title: "Ukraine",
  },
  {
    id: 236,
    name: "United Arab Emirates",
    title: "United Arab Emirates",
  },
  {
    id: 238,
    name: "United States",
    title: "United States",
  },
  {
    id: 239,
    name: "United States Minor Outlying Islands",
    title: "United States Minor Outlying Islands",
  },
  {
    id: 240,
    name: "Uruguay",
    title: "Uruguay",
  },
  {
    id: 241,
    name: "Uzbekistan",
    title: "Uzbekistan",
  },
  {
    id: 242,
    name: "Vanuatu",
    title: "Vanuatu",
  },
  {
    id: 243,
    name: "Vatican City",
    title: "Vatican City",
  },
  {
    id: 244,
    name: "Venezuela",
    title: "Venezuela",
  },
  {
    id: 245,
    name: "Vietnam",
    title: "Vietnam",
  },
  {
    id: 246,
    name: "Virgin Islands, British",
    title: "Virgin Islands, British",
  },
  {
    id: 247,
    name: "Virgin Islands, US",
    title: "Virgin Islands, US",
  },
  {
    id: 248,
    name: "Wallis and Futuna",
    title: "Wallis and Futuna",
  },
  {
    id: 249,
    name: "Western Sahara",
    title: "Western Sahara",
  },
  {
    id: 251,
    name: "Zambia",
    title: "Zambia",
  },
  {
    id: 252,
    name: "Zimbabwe",
    title: "Zimbabwe",
  },
];
